import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TemplateAssignmentSaveFailedAction = {
	type: 'TEMPLATE_ASSIGNMENT_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TemplateAssignmentSaveFailedAction => ({
	type: 'TEMPLATE_ASSIGNMENT_SAVE_FAILED',
	payload,
});
